import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../../Shared/Icon/Icon'

const AttachmentFile = ({ file }) => (
  <div className="section__item">
    <a href={file.attributes.url} download={file.attributes.fileName} className="item-info">
      <div className="item-info__title">
        <Icon type="file" />
        <b>{file.attributes.fileName}</b>
      </div>
      <div className="item-info__date">{file.attributes.uploadDate}</div>
    </a>
  </div>
)

AttachmentFile.propTypes = {
  file: PropTypes.shape({
    attributes: PropTypes.shape({
      url: PropTypes.string.isRequired,
      fileName: PropTypes.string.isRequired,
      uploadDate: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default AttachmentFile
